import { formatDateAndTime } from '@apps/web/lib/date_utils';
import { type JoinedOutreachRead } from '@libraries/typescript/api_client';

const CLOCK_REMINDER_RESOLUTION_REASON_METADATA_KEY =
    'clock_reminder_resolution_reason';
const CLOCK_REMINDER_RESOLUTION_TIME_METADATA_KEY =
    'clock_reminder_resolution_time';

export type ClockReminderResolution = {
    readonly reason: string;
    readonly displayTime: string | null;
};

export function getClockReminderResolution(
    outreach: JoinedOutreachRead,
    timezone: string,
): ClockReminderResolution | null {
    const reason =
        outreach.outreach_metadata?.[
            CLOCK_REMINDER_RESOLUTION_REASON_METADATA_KEY
        ];
    if (typeof reason !== 'string' || reason.trim().length === 0) {
        return null;
    }

    const resolutionTime =
        outreach.outreach_metadata?.[
            CLOCK_REMINDER_RESOLUTION_TIME_METADATA_KEY
        ];
    if (
        typeof resolutionTime !== 'string' ||
        resolutionTime.trim().length === 0
    ) {
        return { reason: reason.trim(), displayTime: null };
    }

    const timestamp = Date.parse(resolutionTime);
    const displayTime = Number.isNaN(timestamp)
        ? resolutionTime.trim()
        : formatDateAndTime(resolutionTime, timezone);
    return { reason: reason.trim(), displayTime };
}

export function formatClockReminderResolution(
    resolution: ClockReminderResolution,
): string {
    if (!resolution.displayTime) {
        return resolution.reason;
    }
    return `${resolution.reason} at ${resolution.displayTime}`;
}
